import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {Stack} from "@mui/joy";
import {IconToggleSwitch, ToggleBar} from "../../../components/ToggleBar.tsx";
import {SortOrder} from "../../../rpc/webrpc-client.gen.ts";
import {useCallback, useState} from "react";
import {TruckDiaryView, TruckTimelineRelay} from "../../../truck/timeline.tsx";
import {defaultPrefs} from "../../../util/defaultPrefs.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {TruckFacetToggleSwitch} from "../../../truck/truckFacetToggleSwitch.tsx";
import {validateAsofSearchParams} from "../../../tstzspan.ts";
import {useStampTruckMutation} from "../../../tq/tqx.tsx";
import {GenericFlavorlessStampSpawnFood} from "../../../stamp/genericFlavorlessStampSpawnFood.tsx";
import {TimelineStampInput} from "../../../stamp/timelineStampInput.tsx";
import {usePreferences} from "../../../agent/usePreferences.ts";

function TruckTimelinePage() {
    const {id: truckId} = Route.useParams();
    const {data: prefs} = usePreferences();
    const [sortOrder, setSortOrder] = useState<SortOrder>((prefs ?? defaultPrefs).truckSortOrder);
    const navigate = useNavigate();
    const bomb = useBomb();
    const {mutateAsync: performStamp} = useStampTruckMutation();
    const doStamp = useCallback((gf: GenericFlavorlessStampSpawnFood) =>
        performStamp({food: {truckId, ...gf}}), [performStamp, truckId]);

    return <PageShell>
        <TruckTimelineRelay truckId={truckId}/>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>

                <ToggleBar>
                    <TruckFacetToggleSwitch dispatchValue={(next) => {
                        navigate({to: `/truck/$id/${next}`, params: {id: truckId}, replace: true})
                            .catch(bomb);
                    }} value="timeline"/>
                    <IconToggleSwitch icons={sortOrderIcons} value={sortOrder} dispatchValue={(next) => {
                        setSortOrder(next);
                    }}/>
                </ToggleBar>

                <TimelineStampInput addStamp={doStamp}/>
            </Stack>
        </PageHeader>
        <PageBody>
            <TruckDiaryView truckId={truckId} sortOrder={sortOrder}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/truck/$id/timeline")({
    component: TruckTimelinePage,
    validateSearch: validateAsofSearchParams,
});


